'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var MESSAGE_BUS_TOPICS = {
    BETSLIP: {
        ADD_SELECTION: 'betslip.leg.add',
        ADD_SELECTION_SUCCESS: 'betslip.events.leg.add.success',
        ADD_SELECTION_FAILURE: 'betslip.events.leg.add.failed',
        REMOVE_SELECTION: 'betslip.leg.remove',
        REMOVE_SELECTION_SUCCESS: 'betslip.events.leg.remove.success',
        REMOVE_SELECTION_FAILURE: 'betslip.events.leg.remove.failed',
        PLACE_BET_SUCCESS: 'betslip.events.bet.place.success',
        CLOSE: 'betslip.close',
        CLEAR: 'betslip.slip.clear',
        CLEAR_SUCCESS: 'betslip.events.slip.clear.success'

    },
    COMMON: {
        LOGIN_STATE: 'gotLoginState',
        LOCAL_FORAGE: 'localForage'
    },
    GAMING: {
        PRODUCT_BALANCE: 'bonus.getProductBonusBalance'
    },
    NATIVE: {
        LOGIN: 'native.login',
        ACCOUNT_DETAILS: 'native.accountdetails'
    },
    SPORTSBOOK: {
        BETSLIP_DRAWER_CLOSE: 'sportsbook.betslipdrawer.close',
        PUSH_SELECTION_UPDATE: 'push.selectionUpdate',
        PUSH_MARKET_UPDATE: 'push.marketUpdate',
        PUSH_EVENT_UPDATE: 'push.eventUpdate',
        ON_ODDS_FORMAT_CHANGED: 'onOddsFormatChanged'
    },
    WEB_PUSH: {
        INIT: 'webpush.init',
        SHOW_ENTRY_POINT: 'webpush.entryPoint.show',
        CHANNEL_ID: 'webpush.channel.id',
        REGISTRATION_BEGIN: 'webpush.registration.begin',
        REGISTRATION_COMPLETE: 'webpush.registration.complete',
        REGISTRATION_ERROR: 'webpush.registration.error',
        TRACKING: {
            OVERLAY_DISPLAYED: 'webpushsignup.events.overlay.displayed',
            OPT_IN_SUCCESS: 'webpushsignup.events.overlay.optin.success',
            OPT_OUT_SUCCESS: 'webpushsignup.events.overlay.optout.success',
            REMIND_LATER_SUCCESS: 'webpushsignup.events.overlay.remindlater.success',
            DISMISS_SUCCESS: 'webpushsignup.events.overlay.dismiss.success'
        }
    }
};
exports.default = MESSAGE_BUS_TOPICS;